// eslint-disable-next-line import/prefer-default-export
export const DiagnosticRange = {
	undefined: 0,
	a:         1,
	b:         2,
	c:         3,
	d:         4,
	disabled:  5,
};
